import React, { LazyExoticComponent, Suspense } from 'react';

const withSuspense = (
    LazyComponent: LazyExoticComponent<() => JSX.Element>,
    fallback?: React.ReactElement
) => {
    return (props: JSX.IntrinsicAttributes) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

export default withSuspense;
